import type { TTicketStatus, TTicketStatusDisplay } from './Tickets.types.ts';

export const ticketStatusDisplays: Record<TTicketStatus, TTicketStatusDisplay> =
  {
    open: {
      badgeVariant: 'information-lighter',
      iconType: 'circle-notch',
      iconColor: 'text-info',
      labelKey: 'tickets.status.open',
    },
    pending: {
      badgeVariant: 'brand-lighter',
      iconType: 'circle-dot',
      iconColor: 'text-brand',
      labelKey: 'tickets.status.pending',
    },
    in_progress: {
      badgeVariant: 'warning-lighter',
      iconType: 'circle-half-stroke',
      iconColor: 'text-warning-darker',
      labelKey: 'tickets.status.inProgress',
    },
    reopened: {
      badgeVariant: 'danger-lighter',
      iconType: 'rotate-right',
      iconColor: 'text-danger',
      labelKey: 'tickets.status.reopened',
    },
    closed: {
      badgeVariant: 'success-lighter',
      iconType: 'circle-check',
      iconColor: 'text-success-darker',
      labelKey: 'tickets.status.closed',
    },
  };
